export default {"src":"/_next/static/media/whatsapp_icon.768dff50.svg","height":40,"width":40};